<template>
  <div class="main-stepper">
    <md-menu md-size="huge" :md-offset-y="6" class="memo-comment">
      <div>
        <md-icon
          v-if="dataMemo.length == 0"
          title="No have memo comment."
          class="icon-gray"
          >chat_bubble</md-icon
        >
        <md-icon v-else md-menu-trigger title="Memo" class="icon-orange"
          >chat_bubble</md-icon
        >
        <!-- <md-icon v-if="(dataMemo.length == 0)" title="No have memo comment." :class="(dataMemo.length == 0) ? 'icon-gray' : 'icon-orange'">chat_bubble</md-icon>
        <md-icon v-else md-menu-trigger title="Memo" :class="(dataMemo.length == 0) ? 'icon-gray' : 'icon-orange'">chat_bubble</md-icon>-->
      </div>
      <md-menu-content class="memo-content">
        <div class="title">Memo</div>
        <div class="detais">
          <div v-for="(item, index) in dataMemo" :key="index">
            <md-menu-item
              :class="index % 2 == 1 ? 'item-card' : 'item-card row-bg-orange'"
            >
              <div style="display: flex">
                <div class="-left-panel">
                  <div class="-circle-gray"></div>
                </div>
                <div class="-right-panel">
                  <div class="-font-kanit -title">
                    {{ item.firstname }} {{ item.u_user }}
                    <span :class="classMemoStatus(item.act_status)">
                      {{ memoStatus(item.act_status) }}
                    </span>
                  </div>
                  <div class="-date">{{ convertDate(item.c_date) }}</div>
                </div>
              </div>
              <div
                class="-font-kanit -comment nowrap-title"
                :title="item.comment"
              >
                {{ item.comment }}
              </div>
              <!-- <div :class="(item.act_status == 'Return') ? '-font-kanit -comment nowrap-title -reject' : '-font-kanit -comment nowrap-title'" :title="item.comment">{{ item.comment }}</div> -->
            </md-menu-item>
          </div>
        </div>
      </md-menu-content>
    </md-menu>

    <div class="step-content" v-if="step == 'step-1'">
      <div class="header-step-stepper">
        <md-avatar class="md-avatar-icon stepper-content-num active"
          >1</md-avatar
        >
        <span class="card-title active">Basic Info</span>
      </div>
      <step1data></step1data>
      <div class="header-step-stepper">
        <md-avatar class="md-avatar-icon stepper-content-num">2</md-avatar>
        <span class="card-title">Select Products</span>
      </div>
      <step2data></step2data>
      <div class="header-step-stepper">
        <md-avatar class="md-avatar-icon stepper-content-num">3</md-avatar>
        <span class="card-title">Condition Sets</span>
      </div>
      <step3data></step3data>
      <!--div class="mktops-action-button-draftandpublish">

<md-button class="mktops-action-button savetodraft">save to draft</md-button>

<md-button class="mktops-action-button publish">publish</md-button>

      </div-->
    </div>
    <div class="step-content" v-if="step == 'step-2'">
      <div class="header-step-stepper">
        <md-avatar class="md-avatar-icon stepper-content-num active">
          <md-icon class="step-icon">mode_edit</md-icon>
        </md-avatar>
        <span class="card-title active">Basic Info</span>
      </div>
      <step1data></step1data>
      <div class="header-step-stepper">
        <md-avatar class="md-avatar-icon stepper-content-num active"
          >2</md-avatar
        >
        <span class="card-title active">Select Products</span>
      </div>
      <step2data></step2data>
      <div class="header-step-stepper">
        <md-avatar class="md-avatar-icon stepper-content-num">3</md-avatar>
        <span class="card-title">Condition Sets</span>
      </div>
      <step3data></step3data>
      <!--div class="mktops-action-button-draftandpublish">

<md-button class="mktops-action-button savetodraft">save to draft</md-button>

<md-button class="mktops-action-button publish">publish</md-button>

      </div-->
    </div>
    <div class="step-content" v-if="step == 'step-3'">
      <div class="header-step-stepper">
        <md-avatar class="md-avatar-icon stepper-content-num active">
          <md-icon class="step-icon">mode_edit</md-icon>
        </md-avatar>
        <span class="card-title active">Basic Info</span>
        <!-- <md-icon class="memo-comment">chat_bubble</md-icon> -->
      </div>
      <step1data></step1data>
      <div class="header-step-stepper">
        <md-avatar class="md-avatar-icon stepper-content-num active">
          <md-icon class="step-icon">mode_edit</md-icon>
        </md-avatar>
        <span class="card-title active">Select Products</span>
      </div>
      <step2data></step2data>
      <div class="header-step-stepper">
        <md-avatar class="md-avatar-icon stepper-content-num active"
          >3</md-avatar
        >
        <span class="card-title active">Condition Sets</span>
      </div>
      <step3data></step3data>

      <div class="mktops-action-button-draftandpublish">
        <div class="select-approval">
          <!-- <multiselect
            v-show="optionsPeople.length > 0"
            v-model="selectedPeople"
            label="firstname"
            track-by="code"
            placeholder="Approval Name"
            :open-direction="'top'"
            :options="optionsPeople"
            :searchable="true"
            :max-height="180"
            :show-no-results="false"
            :custom-label="customLabelPeople"
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
            :hide-selected="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <div>
                <div class="-label">
                  {{ option.firstname }} {{ option.lastname }}
                </div>
              </div>
            </template>
          </multiselect>-->
          <md-field>
            <md-select v-model="selectedPeople">
              <md-option
                v-for="(item, index) in optionsPeople"
                :key="index"
                v-bind:value="item.code"
                >{{ item.firstname }} {{ item.lastname }}</md-option
              >
            </md-select>
          </md-field>
        </div>
        <md-button
          :class="
            true
              ? 'mktops-action-button sendtoapprove'
              : 'mktops-action-button savetodraft'
          "
          @click="showDialog('Pending')"
          >SEND TO APPROVE</md-button
        >
        <!-- <md-button :disabled="checkComplete()?false:true" :class="(checkComplete()?'mktops-action-button sendtoapprove':'mktops-action-button savetodraft')" @click="showDialog('send')">SEND TO APPROVE</md-button> -->
        <!-- <md-button class="mktops-action-button savetodraft" @click="showDialog('draft')">save to draft</md-button>

        <md-button :class="(checkComplete()?'mktops-action-button publish active':'mktops-action-button publish')" @click="showDialog('publish')">publish</md-button>-->
      </div>
    </div>

    <md-dialog-confirm
      :md-active.sync="active"
      md-title="Confirm"
      :md-content="dialog_title"
      md-confirm-text="Sure"
      md-cancel-text="Cancel"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
    />
    <md-dialog-alert
      :md-active.sync="alert"
      md-title="Alert!"
      :md-content="dialog_title"
    />

    <md-dialog
      :md-active.sync="showDialogComment"
      class="promo-memo"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title>Are you sure to publish promotion ?</md-dialog-title>

      <div class="layout-dialog">
        <div v-if="vMax != ''">
          การกำหนดค่า Max ที่ ( {{ vMax }} ) เป็น Rate
          สูงสุดที่ใช้กับโปรโมชั่นชุดนี้
        </div>
        <textarea
          v-model="memoComment"
          placeholder="Please enter the reason."
        ></textarea>
      </div>

      <md-dialog-actions class="-action">
        <md-button class="md-primary -cancel" @click="onClickClose()"
          >CLOSE</md-button
        >
        <md-button
          class="md-primary -save"
          @click="onSaveMemo()"
          :disabled="saveDisabled"
          >SEND TO APPROVE</md-button
        >
      </md-dialog-actions>
    </md-dialog>
    <md-snackbar
      :md-position="`center`"
      :md-active.sync="showSnack"
      :md-duration="20000"
      md-persistent
    >
      <span>{{ dContent }}</span>
      <md-button class="md-primary" @click="showSnack = false">OK</md-button>
    </md-snackbar>

    <md-dialog-confirm
      :md-active.sync="activeSave"
      md-title="Confirm"
      md-content="Are you sure to send to approve ?"
      md-confirm-text="Sure"
      md-cancel-text="Cancel"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
      :disabled="saveDisabled"
    />
    <md-dialog-confirm
      :md-active.sync="activeMaxValue"
      md-title="Are you sure to send to approve ?"
      :md-content="dialog_title_max"
      md-confirm-text="Sure"
      md-cancel-text="Cancel"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
      :disabled="saveDisabled"
    />
  </div>
</template>

<script>
import moment from "moment-timezone";
import CipherService from "@/services/cipher";
import promotionService from "@/services/promotion";
export default {
  name: "stepper",
  components: {
    step1data: require("@/components/promotion/create/stepper/step-1-data")
      .default,
    step2data: require("@/components/promotion/create/stepper/step-2-data")
      .default,
    step3data: require("@/components/promotion/create/stepper/step-3-data")
      .default,
  },
  created() {
    let self = this;
    let user = this.$jwt.decode(localStorage.getItem("token"));

    CipherService.getBossCode(user.code)
      .then((response) => {
        user = {
          code: user.code,
          boss_code:
            response.resource.length > 0 ? response.resource[0].boss_code : "",
        };

        // if (
        //   user.boss_code !== undefined &&
        //   user.boss_code !== "" &&
        //   user.boss_code !== null
        // ) {
        promotionService.getApproveBy(user).then((response) => {
          if (response && response.length > 0) {
            self.optionsPeople = response;

            /*-- START New Flow Approve --*/
            // if (this.value["approve_by"] === undefined) {
            if (this.value === undefined) {
              let index = this.optionsPeople.findIndex(
                (item) => item.code === user.boss_code
              );
              if (index > -1) {
                this.selectedPeople = this.optionsPeople[index].code;
              } else {
                this.selectedPeople = this.optionsPeople[0].code;
              }
            } else {
              let index = this.optionsPeople.findIndex(
                (item) => item.code === this.value["approve_by"]
              );
              if (index > -1) {
                this.selectedPeople = this.optionsPeople[index].code;
              } else {
                this.selectedPeople = this.optionsPeople[0].code;
              }
            }
            /*-- END New Flow Approve --*/
          }
        });
        // }
      })
      .catch((error) => console.log(error));

    // if (
    //   user.boss_code !== undefined &&
    //   user.boss_code !== "" &&
    //   user.boss_code !== null
    // ) {
    //   promotionService.getApproveBy(user).then(response => {
    //     if (response && response.length > 0) {
    //       self.optionsPeople = response;

    //       /*-- START New Flow Approve --*/
    //       if (this.value["approve_by"] === undefined) {
    //         let index = this.optionsPeople.findIndex(
    //           item => item.code === user.boss_code
    //         );
    //         if (index > -1) {
    //           this.selectedPeople = this.optionsPeople[index].code;
    //         }
    //       } else {
    //         let index = this.optionsPeople.findIndex(
    //           item => item.code === this.value["approve_by"]
    //         );
    //         if (index > -1) {
    //           this.selectedPeople = this.optionsPeople[index].code;
    //         }
    //       }
    //       /*-- END New Flow Approve --*/
    //     }
    //   });
    // }
  },
  mounted() {
    this.dataMemo = this.$store.getters["pmcreate/value"].wf;
  },
  computed: {
    step() {
      return this.$store.getters["pmcreate/step"];
    },
    value() {
      let sets = this.$store.getters["pmcreate/value"].sets;
      let index_max_set = sets.length - 1;
      let index_max_con = sets[index_max_set].conditions.length - 1;
      if (
        index_max_con >= 0 &&
        !sets[index_max_set].conditions[index_max_con].max_level
      ) {
        this.vMax = sets[index_max_set].conditions[index_max_con].max;
      } else {
        this.vMax = "";
      }

      return this.$store.getters["pmcreate/value"];
    },
  },
  data: () => ({
    selectedPeople: [],
    optionsPeople: [],
    saveDisabled: false,
    memoComment: "",
    showDialogComment: false,
    dataMemo: 0,
    alert: false,
    active: false,
    type: null,
    dialog_title: null,
    showSnack: false,
    dContent: "",
    vMax: "",
    dialog_title_max: null,
    activeMaxValue: false,
    activeSave: false,
  }),
  methods: {
    customLabelPeople({ firstname, lastname }) {
      return `${firstname} ${lastname}`;
    },
    clearAll(id, type) {
      this.selectedPeople = [];
    },
    async onSaveMemo() {
      this.saveDisabled = true;
      this.$store.commit("pmmanage/loadingPage", true);
      this.$store.commit("pmcreate/setComment", this.memoComment);
      this.$store.dispatch("pmcreate/setFormatDate");
      this.$store.commit("pmcreate/setType", this.type);
      let create_rs = await this.$store.dispatch(
        "pmcreate/createPromotionToServer"
      );
      if (create_rs === false) {
        this.$store.commit("pmmanage/loadingPage", false);
        this.dContent = "Can not get approve by.";
        this.showSnack = true;
        this.saveDisabled = false;
      }
      this.showDialogComment = false;
      this.memoComment = "";
    },
    onClickClose() {
      this.showDialogComment = false;
    },
    convertDate(date) {
      // return moment(new Date(date)).format("hh:mm A MMMM D, YYYY");
      return moment(new Date(date)).format("HH:MM MMMM D, YYYY");
      // return moment(new Date(date)).format("MMMM D, YYYY HH:MM");
    },
    classMemoStatus(status) {
      if (status == "Draft") {
        return "memo-chip -gray";
      } else if (status == "Active") {
        return "memo-chip -green";
      } else if (status == "Return") {
        return "memo-chip -red";
      } else if (status == "Pending") {
        return "memo-chip -yellow";
      } else if (status == "Inactive") {
        return "memo-chip -blue";
      }
    },
    memoStatus(status) {
      if (status == "Draft") {
        return "Draft";
      } else if (status == "Active") {
        return "Active";
      } else if (status == "Return") {
        return "Reject";
      } else if (status == "Pending") {
        return "Send to approve";
      } else if (status == "Inactive") {
        return "Inactive";
      }
    },
    showDialog(type) {
      if (type === "draft") {
        this.dialog_title = "Are you sure to save draft?";
        this.type = type;
        this.active = true;
      } else {
        if (this.optionsPeople.length === 0) {
          this.alert = true;
          return (this.dialog_title = "Can not get approve by.");
          return false;
        } else if (this.selectedPeople === "" || this.selectedPeople === null) {
          this.alert = true;
          return (this.dialog_title = "Please select Approval Name.");
          return false;
        } else {
          var checkComplete = this.checkComplete(type);
        }
        // if (checkComplete === true) {
        //     // this.dialog_title = 'Are you sure to publish promotion?'
        //     this.type = type
        //     this.showDialogComment = true;
        //     // this.active = true
        // } else {
        //     this.dialog_title = checkComplete
        //     this.type = 'InComplete'
        //     this.alert = true
        // }
      }
    },
    checkComplete(type) {
      const sets = this.value.sets;
      var count_ck_sets = 0;
      var set_fail = [];

      let name_set = [];
      let vMax = "";

      /* check alert have net_price by item */
      let setsLength = sets.length;
      let lastSet = sets[setsLength - 1];
      let net_price = "";
      lastSet.promotions.forEach(function (item, key) {
        if (item.type === "Net Price") {
          net_price = item.value;
        }
      });

      let products = this.value.products;
      let self = this;
      let check = false;
      let checknetprice = 0;
      products.forEach(function (item) {
        // if(net_price !== ''){
        //     if(item.netprice !== undefined){
        //         self.dialog.content = `Are you sure to set Net price so have Net price by product `;
        //         self.dialog.active = true;
        //     }
        // }

        if (item.min == "" || item.max == "") {
          check = true;
          return;
        }

        if (parseFloat(item.netprice) > 0) {
          checknetprice++;
        }
      });

      if (checknetprice > 0) {
        this.$store.commit("pmcreate/setNetPriceFlag", true);
      }

      for (const x in sets) {
        // if((check) && sets[x].conditions.length == 0) {
        //     this.alert = true;
        //     return this.dialog_title = "Please enter min-max net price on step 2 Or Please select Conditions";
        // }

        if (name_set.indexOf(sets[x].name) == -1) {
          name_set.push(sets[x].name);
        } else {
          this.alert = true;
          return (this.dialog_title =
            '"' + sets[x].name.toUpperCase() + '"' + " duplicate set name");
        }

        if (sets[x].customers.length <= 0) {
          this.alert = true;
          return (this.dialog_title = "Please select customer");
        }

        if (sets[x].name == "") {
          this.value.sets[x].name = "SET " + (parseFloat(x) + 1);
        }

        if (sets[x].default_price || sets[x].default_price == "") {
          if (sets[x].name == "") {
            this.alert = true;
            return (this.dialog_title = "Please input Name");
          } else if (sets[x].customers.length <= 0) {
            this.alert = true;
            return (this.dialog_title = "Please select customer");
          } else if (
            sets[x].default_price == "" ||
            sets[x].default_price == null
          ) {
            this.alert = true;
            return (this.dialog_title = "Please select Price Type");
          }
        }

        if (setsLength > 1 && sets[x].conditions.length == 0) {
          this.alert = true;
          return (this.dialog_title = "Please select Conditions");
        }

        if (sets[x].conditions.length > 0) {
          if (sets[x].conditions[0].type == "Count Mix") {
            if (
              sets[x].conditions[0].count === undefined ||
              sets[x].conditions[0].count == ""
            ) {
              this.alert = true;
              return (this.dialog_title = "Please input Count Item (≥)");
            }

            if (
              (sets[x].conditions[0].min == "" ||
                sets[x].conditions[0].min == null) &&
              (sets[x].conditions[0].max == "" ||
                sets[x].conditions[0].max == null)
            ) {
              this.alert = true;
              return (this.dialog_title =
                "QTY min can not null <br> QTY max can not null");
            }
            if (
              (sets[x].conditions[0].min_value == "" ||
                sets[x].conditions[0].min_value == null) &&
              (sets[x].conditions[0].max_value == "" ||
                sets[x].conditions[0].max_value == null)
            ) {
              this.alert = true;
              return (this.dialog_title =
                "Value min can not null <br> Value max can not null");
            }

            if (
              sets[x].conditions[0].min != "" &&
              sets[x].conditions[0].min != null &&
              (sets[x].conditions[0].max == "" ||
                sets[x].conditions[0].max == null)
            ) {
              this.alert = true;
              return (this.dialog_title = "QTY max can not null");
            }
            if (
              sets[x].conditions[0].min_value != "" &&
              sets[x].conditions[0].min_value != null &&
              (sets[x].conditions[0].max_value == "" ||
                sets[x].conditions[0].max_value == null)
            ) {
              this.alert = true;
              return (this.dialog_title = "Value max can not null");
            }

            if (
              sets[x].conditions[0].max != "" &&
              sets[x].conditions[0].max != null &&
              (sets[x].conditions[0].min == "" ||
                sets[x].conditions[0].min == null)
            ) {
              this.alert = true;
              return (this.dialog_title = "QTY min can not null");
            }
            if (
              sets[x].conditions[0].max_value != "" &&
              sets[x].conditions[0].max_value != null &&
              (sets[x].conditions[0].min_value == "" ||
                sets[x].conditions[0].min_value == null)
            ) {
              this.alert = true;
              return (this.dialog_title = "Value min can not null");
            }

            if (
              sets[x].conditions[0].min == "" ||
              sets[x].conditions[0].min == null
            ) {
              this.alert = true;
              return (this.dialog_title = "QTY min can not null");
            } else if (
              sets[x].conditions[0].min_value == "" ||
              sets[x].conditions[0].min_value == null
            ) {
              this.alert = true;
              return (this.dialog_title = "Value min can not null");
            } else if (
              sets[x].conditions[0].max == "" ||
              sets[x].conditions[0].max == null
            ) {
              this.alert = true;
              return (this.dialog_title = "QTY max can not null");
            } else if (
              sets[x].conditions[0].max_value == "" ||
              sets[x].conditions[0].max_value == null
            ) {
              this.alert = true;
              return (this.dialog_title = "Value max can not null");
            } else if (
              parseFloat(sets[x].conditions[0].min) >
              parseFloat(sets[x].conditions[0].max)
            ) {
              this.alert = true;
              return (this.dialog_title =
                "QTY max must be greater than QTY min");
            } else if (
              parseFloat(sets[x].conditions[0].min_value) >
              parseFloat(sets[x].conditions[0].max_value)
            ) {
              this.alert = true;
              return (this.dialog_title =
                "Value max must be greater than Value min");
            }
          } else {
            if (
              (sets[x].conditions[0].type == "Count Item" ||
                sets[x].conditions[0].type == "Count Value") &&
              (sets[x].conditions[0].count === undefined ||
                sets[x].conditions[0].count == "")
            ) {
              this.alert = true;
              return (this.dialog_title = "Please input Count Item (≥)");
            }

            if (
              (sets[x].conditions[0].type == "Count Item" ||
                sets[x].conditions[0].type == "Count Value") &&
              (sets[x].conditions[0].min == "" ||
                sets[x].conditions[0].min == null) &&
              (sets[x].conditions[0].max == "" ||
                sets[x].conditions[0].max == null)
            ) {
              this.alert = true;
              return (this.dialog_title =
                "Value min can not null <br> Value max can not null");
            }

            if (
              (sets[x].conditions[0].type == "Count Item" ||
                sets[x].conditions[0].type == "Count Value") &&
              sets[x].conditions[0].min != "" &&
              sets[x].conditions[0].min != null &&
              (sets[x].conditions[0].max == "" ||
                sets[x].conditions[0].max == null)
            ) {
              this.alert = true;
              return (this.dialog_title = "Value max can not null");
            }

            if (
              (sets[x].conditions[0].type == "Count Item" ||
                sets[x].conditions[0].type == "Count Value") &&
              sets[x].conditions[0].max != "" &&
              sets[x].conditions[0].max != null &&
              (sets[x].conditions[0].min == "" ||
                sets[x].conditions[0].min == null)
            ) {
              this.alert = true;
              return (this.dialog_title = "Value min can not null");
            }

            if (
              (sets[x].conditions[0].type != "Count Item" ||
                sets[x].conditions[0].type == "Count Value") &&
              (sets[x].conditions[0].min == "" ||
                sets[x].conditions[0].min == null)
            ) {
              this.alert = true;
              return (this.dialog_title = "Value min can not null");
            } else if (
              (sets[x].conditions[0].type != "Count Item" ||
                sets[x].conditions[0].type == "Count Value") &&
              (sets[x].conditions[0].max == "" ||
                sets[x].conditions[0].max == null)
            ) {
              this.alert = true;
              return (this.dialog_title = "Value max can not null");
            } else if (
              (sets[x].conditions[0].type != "Count Item" ||
                sets[x].conditions[0].type == "Count Value") &&
              parseFloat(sets[x].conditions[0].min) >
                parseFloat(sets[x].conditions[0].max)
            ) {
              this.alert = true;
              return (this.dialog_title =
                "Value max must be greater than value min");
            }
          }

          // if (sets[x].promotions.length == 0) {
          // if (sets[x].promotions.length == 0 && checknetprice == 0) {
          //     this.alert = true;
          //     return this.dialog_title = 'Please select "Set your Promotion"';
          // }

          if (sets[x].default_price == "" || sets[x].default_price == null) {
            this.alert = true;
            return (this.dialog_title = "Please select Price Type");
          }

          if (
            sets[x].conditions[0].type != "Count Item" ||
            sets[x].conditions[0].type == "Count Value"
          ) {
            vMax = sets[x].conditions[0].max;
          }
        }

        if (sets[x].promotions.length > 0) {
          if (sets[x].conditions.length == 0) {
            this.alert = true;
            return (this.dialog_title = "Please select Condition");
          }

          for (const y in sets[x].promotions) {
            // sets[x].promotions[y].value != 0 &&
            if (
              sets[x].promotions[y].type != 'Free item' &&
              (sets[x].promotions[y].value == "" ||
              sets[x].promotions[y].value == null ||
              isNaN(sets[x].promotions[y].value) === true)
            ) {
              this.alert = true;
              return (this.dialog_title =
                "Value of " + sets[x].promotions[y].type + " can not null");
            }
          }

          if (sets[x].default_price == "" || sets[x].default_price == null) {
            this.alert = true;
            return (this.dialog_title = "Please select Price Type");
          }
        }
      }
      // this.$store.dispatch('pmcreate/ck_range')
      // let alert = this.$store.getters['pmcreate/alert']
      // let ck_value_condition = (alert.length ? false : true)
      // if (ck_value_condition === false) {
      //     return alert;
      // }

      this.$store.dispatch("pmcreate/ck_range");
      let alert = this.$store.getters["pmcreate/alertCondition"];
      let ck_value_condition = alert.length ? false : true;
      if (alert) {
        this.dialog_title = alert;
        this.alert = true;
        return;
      }

      if (ck_value_condition) {
        if (this.value.type == "Return" && type !== "Pending") {
          type = "Return";
        }

        this.type = type;
        let index_max_set = sets.length - 1;
        let index_max_con = sets[index_max_set].conditions.length - 1;

        this.value["approve_by"] = this.selectedPeople;

        if (
          sets[index_max_set].conditions.length > 0 &&
          (sets[index_max_set].conditions[index_max_con].type == "Count Item" ||
            sets[index_max_set].conditions[index_max_con].type ==
              "Count Value") &&
          (sets[index_max_set].conditions[index_max_con].min == "" ||
            sets[index_max_set].conditions[index_max_con].min == null) &&
          (sets[index_max_set].conditions[index_max_con].max == "" ||
            sets[index_max_set].conditions[index_max_con].max == null)
        ) {
          this.activeSave = true;
        } else {
          if (
            index_max_con >= 0 &&
            !sets[index_max_set].conditions[index_max_con].max_level
          ) {
            let vMax = sets[index_max_set].conditions[index_max_con].max;
            this.dialog_title_max =
              "<div class='alert-max'> การกำหนดค่า Max ที่ (" +
              vMax +
              ") เป็น Rate สูงสุดที่ใช้กับโปรโมชั่นชุดนี้ </div>";
            this.activeMaxValue = true;
          } else {
            this.activeSave = true;
          }
        }
      } else {
        let word_fail = "Please recheck your ";
        for (const x in set_fail) {
          word_fail += "SET" + (parseInt(set_fail[x]) + 1) + " ";
        }
        this.dialog_title = word_fail;
        this.alert = true;
      }

      // if (this.value.promotion_code && this.value.promotion_title && this.value.startdate && this.value.enddate && this.value.products.length > 0 && (count_ck_sets == sets.length) && ck_value_condition) {
      // return true;
      // } else {
      //     let word_fail = 'Please recheck your '
      //     for (const x in set_fail) {
      //         word_fail += 'SET' + (parseInt(set_fail[x]) + 1) + ' '
      //     }
      //     return word_fail
      // }
    },
    onConfirm() {
      this.showDialogComment = true;
      // this.$store.dispatch('pmcreate/setFormatDate')
      // this.$store.commit('pmcreate/setType', this.type)
      // this.$store.dispatch('pmcreate/createPromotionToServer')
    },
    onCancel() {
      this.active = false;
      this.activeMaxValue = false;
      return false;
    },
  },
};
</script>

<style>
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.main-stepper
  > div
  > div.mktops-action-button-draftandpublish
  > button.sendtoapprove {
  background-color: #3f51b5;
  width: 150px;
  height: 36px;
}

#app
  .mktops-maincontent
  .mktops-stepper
  .main-stepper
  .step-content
  .step-content-lint-text
  .step-content-line-step3
  .text
  .md-card.mkt-card-step3 {
  border: #efefef;
  border-width: 1px;
}
</style><style lang="scss">
.mktops-stepper {
  width: 100%;

  .main-content {
    width: 75%;
    margin-right: 0px;
  }
  .main-stepper {
    width: 25%;
    padding-left: 20px;
    height: calc(100vh - 195px) !important;
    overflow-y: auto;

    &::-webkit-scrollbar {
      height: 7px;
      width: 5px;
    }

    .step-content .step-content-line-step3 .md-card {
      position: unset !important;
    }

    .multiselect {
      .z-index-top {
        z-index: 10;
      }

      margin: 5px 0px;

      .multiselect__single,
      .multiselect__input {
        font-size: 14px;

        div {
          display: flex;
          width: 100%;

          .-delete {
            width: 10%;

            .material-icons {
              font-size: 18px;
              margin-top: 1px;
              cursor: pointer;
              color: gray;
            }
          }
        }
      }

      .multiselect__tags {
        padding: 8px 30px 0 8px;

        input {
          font-family: lato;
          font-weight: 300;
        }

        .multiselect__placeholder {
          margin: 0px;
        }

        ::placeholder {
          color: #bdbdbd;
          opacity: 1;
        }
      }

      .multiselect__content-wrapper,
      .multiselect__content {
        font-size: 14px;
        z-index: 100;
      }

      .multiselect__option {
        min-height: 34px;
        padding: 12px 12px 0px 12px;
      }

      ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
    }
  }

  .mktops-action-button-draftandpublish {
    position: fixed;
    bottom: 28px;
    width: 19%;

    button.sendtoapprove {
      margin: 7px 0px;
    }

    .select-approval {
      width: 100%;
      margin: 0px;

      .md-field:after,
      .md-field:before {
        left: unset;
      }

      .md-field.md-theme-default,
      .md-field.md-theme-default.md-has-value {
        margin-bottom: 5px;
        margin-top: 0px;
        padding-top: 12px;
      }

      .md-select {
        background-color: #efefef;
        border-radius: 3px;

        input {
          padding-left: 15px;
        }
      }
    }
  }
}

.memo-comment {
  // position: relative;
  // left: 60% !important;
  position: absolute;
  right: 1% !important;
  top: 2% !important;
  cursor: pointer;

  .md-icon {
    &.icon-gray {
      color: #97b1b1 !important;
    }
    &.icon-orange {
      color: #fd7f00 !important;
    }
  }
}

.memo-content {
  width: 400px;
  max-width: 420px !important;
  height: 350px;
  max-height: 351px !important;
  left: unset !important;
  right: 15px !important;
  background-color: #efefef !important;

  .md-list.md-theme-default {
    padding: 0;
  }

  .md-menu-content-container {
    overflow: unset;
  }

  .title {
    text-align: center;
    color: #727272;
    font-size: 16px;
    font-weight: bold;
    height: 40px;
    padding-top: 12px;
    // padding-left: 10px;
  }

  .detais {
    height: 300px;
    overflow-y: scroll;
    background-color: #ffffff;

    .item-card {
      // height: 80px;
      // margin: 5px 5px 8px 5px;
      cursor: text;

      &.row-bg-orange {
        border-radius: 4px;

        div {
          background: #fdf5df;
        }
      }

      .nowrap-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .md-list-item-container {
        display: flex;
      }

      .md-list-item-content {
        padding-top: 8px;
        padding-left: 10px;
        display: table-cell;
        vertical-align: middle;
        height: 80px;

        .-font-kanit {
          font-size: 14px;
          font-family: kanit;
        }

        .-title {
          font-size: 13px;
          color: #767676;

          .memo-chip {
            padding-left: 5px;
            padding-right: 5px;
            border-radius: 50px;
            color: #ffffff;
            font-size: 10px;
            margin-left: 5px;
            max-height: 16px;
            line-height: 16px;

            &.-gray {
              background-color: #a8a8a8;
            }
            &.-green {
              background-color: #64a064;
            }
            &.-red {
              background-color: #f44336;
            }
            &.-yellow {
              background-color: #fbc02d;
            }
            &.-blue {
              background-color: #2b9cfd;
            }
          }
        }

        .-date {
          margin-top: 5px;
          color: #a8a8a8;
        }

        .-comment {
          margin-top: 10px;
          color: #727272;

          &.-italic {
            font-style: italic;
          }
        }
      }

      .-left-panel {
        width: 12%;
        .-circle-gray {
          width: 32px;
          height: 32px;
          background-color: #efefef;
          border-radius: 4px;
          margin-top: 5px;
        }
      }

      .-right-panel {
        width: 88%;
      }
    }

    &::-webkit-scrollbar {
      height: 7px;
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background-color: #ffffff;
    }
  }

  div {
    width: 100%;
    font-size: 11px;
    font-family: lato;
  }

  ul {
    border-radius: 5px;
    background-color: #efefef !important;
  }
}
</style>
